import React, { useState, useContext, useEffect } from "react";
import {
  Modal,
  Paper,
  IconButton,
  InputAdornment,
  Button,
  TextField,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import CancelIcon from "@material-ui/icons/Close";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import EcoIcon from "@material-ui/icons/Eco";
import EmailIcon from "@material-ui/icons/EmailOutlined";
import { useMediaQuery } from "react-responsive";

import { Context as InvoicesContext } from "../context/invoices.context";
import { Context as AuthContext } from "../context/auth.context";

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

const EinvoicingModal = (props) => {
  const [agreeChecked, setAgreeChecked] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailValidated, setEmailValidated] = useState(false);
  const { state, setEinvoicingModalOpen } = useContext(InvoicesContext);
  const authContext = useContext(AuthContext);

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });

  useEffect(() => {
    validateEmail(authContext.state.email);
  }, []);

  const validateEmail = (email) => {
    setEmail(email);

    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      setEmailValidated(true);
      setEmailError(false);
    } else {
      setEmailValidated(false);
      setEmailError(true);
    }
  };

  const xLang = (string) => {
		return string
	}

  const renderContent = () => {
    return (
      <>
        {/* <Typography style={{ marginBottom: 50 }} variant={"h4"}>
            Select auto pay payment method...
          </Typography> */}
        <Alert
          severity="success"
          style={{ marginBottom: 25, textAlign: "left" }}
          icon={<EcoIcon />}
        >
          <b><x-lang>IMPORTANT</x-lang>:</b> <x-lang>By clicking the “I Agree” checkbox below, you agree
          to receive your invoices via electronic means (E-Invoicing), which
          will come in the form of an email to the address on file and be
          available in this portal. This invoice will include details of your
          bill and an easy way to pay through our payment partner Intellipay.
          These emails will come from noreply@intellipay.com, which you should
          add to your email contacts to ensure delivery to your Inbox. We
          believe this step will reduce cost and time in our billing process and
          simplify your payment options.</x-lang>
        </Alert>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
            marginBottom: 25,
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={agreeChecked}
                onChange={(e) => setAgreeChecked(e.target.checked)}
                name="agreeChecked"
                color="primary"
              />
            }
            label={xLang("I agree to enroll in paperless e-billing")}
          />
        </div>
        <TextField
          id="outlined-basic"
          label={xLang("Email")}
          variant="outlined"
          value={email}
          error={emailError}
          onChange={(e) => validateEmail(e.target.value)}
          fullWidth
          helperText="Email address where paperless invoices will be sent"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <EmailIcon />
              </InputAdornment>
            ),
          }}
          style={{ marginBottom: 15 }}
        />
        <div style={styles.buttonsContainer}>
          <Button
            variant="contained"
            onClick={() => setEinvoicingModalOpen(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="secondary"
            style={{ color: "white", marginLeft: 25 }}
            onClick={() => {
              props.setEinvoicingEnabled(true);
              localStorage.setItem("einvoicing_enabled", "true");
              setEinvoicingModalOpen(false);
            }}
            disabled={!agreeChecked || !emailValidated ? true : false}
          >
            <x-lang>ENROLL</x-lang>
          </Button>
        </div>
      </>
    );
  };

  return (
    <Modal
      open={state.eInvoicingModalOpen}
      onClose={() => setEinvoicingModalOpen(false)}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        outline: "none",
        width: "100%",
      }}
    >
      <Paper
        elevation={3}
        style={{
          ...styles.container,
          width: isTabletOrMobile ? "calc(100% - 30px)" : 600,
          padding: isTabletOrMobile ? 15 : 50,
          paddingTop: isTabletOrMobile ? 55 : 50,
        }}
      >
        <IconButton
          style={{
            position: "absolute",
            top: isTabletOrMobile ? 5 : 5,
            right: isTabletOrMobile ? 5 : 5,
          }}
          onClick={() => setEinvoicingModalOpen(false)}
        >
          <CancelIcon />
        </IconButton>
        {renderContent()}
      </Paper>
    </Modal>
  );
};

const styles = {
  container: {
    padding: 50,
    background: "white",
    outline: "none",
    borderRadius: 5,
    position: "relative",
    textAlign: "center",
  },
  typeContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    border: "1px solid #e8e8e8 ",
    marginBottom: 15,
    padding: 15,
    paddingRight: 25,
    borderRadius: 5,
    cursor: "pointer",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
    marginBottom: 25,
  },
  creditCardVisa: {
    height: 200,
    width: 300,
    background: "linear-gradient(to right,#004887,#0078a3)",
    borderRadius: 10,
  },
  cardMaster: {
    height: 200,
    width: 300,
    borderRadius: 10,
    background: "linear-gradient(90deg, #d53369 0%, #daae51 100%)",
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    justifyContent: "flex-end",
  },
};

export default EinvoicingModal;
